import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScript = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M7.007 4.557c0-.902.731-1.633 1.633-1.633h4.734a1.633 1.633 0 1 1 0 3.266H8.64a1.633 1.633 0 0 1-1.633-1.633m-4.508 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M3.007 10c0-.902.731-1.633 1.633-1.633h6.734a1.633 1.633 0 1 1 0 3.266H4.64A1.633 1.633 0 0 1 3.007 10m11.495 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-7.495 5.443c0-.902.731-1.633 1.633-1.633h6.734a1.633 1.633 0 1 1 0 3.266H8.64a1.633 1.633 0 0 1-1.633-1.633m-4.508 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" />
  </svg>
);
export default SvgScript;
